import { useState } from 'react';

import { useUserData } from 'core/Api';
import { getErrorMessage_v2 } from 'core/Utils';
import { useExportUserPurchaseHistory } from 'store/Api';
import { Alert, ButtonMantine, Group, Modal, Stack, Text, Title, notifications } from 'ui';
import { useDisclosure } from 'ui/Hooks';
import { IconCircleCheck, IconFilter } from 'ui/Icons';

import { useUserPurchasesSearchContext } from '../PurchaseSearchContext';

const ExportPurchasesModal = ({ opened, onClose }: { opened: boolean; onClose: () => void }) => {
  const [success, setSuccess] = useState(false);
  const { data: userData } = useUserData();
  const { mutate: sendUserPurchaseHistory } = useExportUserPurchaseHistory();

  const ctx = useUserPurchasesSearchContext();

  const handleSend = () => {
    sendUserPurchaseHistory(ctx.UserPurchasesSearchObject ?? {}, {
      onSuccess: () => {
        setSuccess(true);
      },
      onError: (e) => {
        notifications.show({
          message: getErrorMessage_v2(e),
          variant: 'error',
        });
      },
    });
  };

  const handleClose = () => {
    onClose();
    setSuccess(false);
  };

  return (
    <Modal
      opened={opened}
      onClose={() => {
        if (success) {
          return handleClose();
        }
        onClose();
      }}
      title={
        success ? (
          <Group justify="center" style={{ flexGrow: 1, marginLeft: 'auto', marginRight: 'auto' }}>
            <IconCircleCheck color={'#68C097'} size={64} />
          </Group>
        ) : (
          'Send to Email'
        )
      }
      styles={{ title: { width: '100%' } }}
    >
      <Stack gap="lg">
        {success ? (
          <>
            <Stack gap="xs">
              <Title order={2}>Your CSV summary will be sent to your email shortly</Title>
              <Text fz={14} c="gray">
                Please check your email in a few minutes to view your summary.
              </Text>
            </Stack>
          </>
        ) : (
          <>
            <Stack gap="xs">
              <Text fz={14} c="gray">
                We will send you a CSV summary of your Purchases. You can apply filters to this
                summary below.
              </Text>
              <Text fz={14} fw={500}>
                {userData?.email}
              </Text>
            </Stack>
            <Alert
              type="info-blue"
              title="To filter this summary, apply filters on the purchases page before exporting."
              icon={<IconFilter />}
            />
          </>
        )}
        <ButtonMantine fullWidth onClick={success ? handleClose : handleSend}>
          {success ? 'Okay, thanks!' : 'Send'}
        </ButtonMantine>
      </Stack>
    </Modal>
  );
};

const ExportPurchasesModalButton = () => {
  const [opened, handlers] = useDisclosure(false);
  return (
    <>
      <ButtonMantine
        fullWidth
        onClick={() => {
          handlers.open();
        }}
      >
        Export Purchases
      </ButtonMantine>
      <ExportPurchasesModal opened={opened} onClose={() => handlers.close()} />
    </>
  );
};

export { ExportPurchasesModalButton };
